import classNames from "classnames";
import React, { ComponentProps, forwardRef } from "react";

import "./text-field.css";

type TextFieldProps = {
	isFullWidth?: boolean;
} & ComponentProps<"input">;

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
	({ className, isFullWidth, ...props }, ref) => {
		const cssClass = classNames([
			"text-field",
			{ "text-field--full-width": isFullWidth },
			className,
		]);

		return <input type="text" className={cssClass} ref={ref} {...props} />;
	},
);
TextField.displayName = "TextField";
